import { Controller } from "@hotwired/stimulus"
import { useIntersection, useThrottle, useVisibility, useWindowResize } from "stimulus-use"
import setIntervalPlus from "@/interval-plus"

export default class extends Controller {
    static throttles = [
        'active'
    ]


    static targets = [
        'container',
        'content',
        'button',
        'video'
    ]

    static values = {
        index: {
            type: Number,
            default: 0,
        }
    }

    clicked = false

    connect() {
        useThrottle(this, { wait: 300 })

        this.interval = setIntervalPlus(() => {
            this.change()
        }, 10000);

        this.recalc()

        this.change()

        useWindowResize(this)
        useIntersection(this)
        useVisibility(this)
    }

    windowResize() {
        this.recalc()
    }

    recalc() {
        this.containerTarget.style.minHeight = 0

        const px = Math.max.apply(Math, this.contentTargets.map(function (element) {
            return element.scrollHeight
        }))

        this.containerTarget.style.minHeight = `${px}px`
    }

    visible() {
        this.interval.resume()
    }

    invisible() {
        this.interval.pause()
    }

    appear() {
        this.interval.resume()
    }

    disappear() {
        this.interval.pause()
    }

    change() {
        this.contentTargets.forEach((element, index) => {
            element.setAttribute(this.activeContentAttribute, index === this.indexValue)
        })

        this.videoTargets.forEach((element, index) => {
            element.setAttribute(this.activeVideoAttribute, index === this.indexValue)
        })

        this.buttonTargets.forEach((element, index) => {
            const isIndex = index === this.indexValue;
            element.classList.toggle('active', !this.clicked && isIndex)
            element.classList.toggle('active-clicked', this.clicked && isIndex)
        })

        this.indexValue++

        if (this.indexValue >= this.contentTargets.length) {
            this.indexValue = 0
        }
    }

    active({ params: { index } }) {
        this.clicked = true
        this.indexValue = index
        this.change()
        this.interval.stop()
    }

    disconnect() {
        this.interval.stop()
    }

    get activeContentAttribute() {
        return `data-slash-screen--content-active-value`;
    }

    get activeVideoAttribute() {
        return `data-slash-screen--video-active-value`;
    }
}